import React from "react";
import CommonControl from "./CommonControl";
import { useTranslation } from "react-i18next";

const ExternalPoliceDept = (props) => {
  const { t } = useTranslation("form");
  return (
    <React.Fragment>
      <CommonControl {...props} keyName={'exteralPoliceDepartment'} title={t("externalPoliceDept")} arr={['role','first_name_prefix','last_name','email','phone']} required={false} />
    </React.Fragment>
  );
};

export default ExternalPoliceDept;
